import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import Wrapper from '../wrapper/Wrapper';
import { Container, Row, Col } from 'react-bootstrap';
import { LocationFinder } from "./LocationFinder";
import LocationAzureMap from "./AzureMap";
import { connect } from 'react-redux';
import { locationDuck } from "../../ducks/location"; //MediaQuery

import MediaQuery from 'react-responsive';
var locationOperations = locationDuck.operations;

var LocationMap = function LocationMap(props) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActive = _useState2[1];

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "overflow-hidden"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "7",
    className: "p-0"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(ConnectLocationAzureMap, _extends({}, props, {
    height: 900,
    activeTab: activeTab
  }))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(ConnectLocationAzureMap, _extends({}, props, {
    height: 250,
    activeTab: activeTab
  })))), /*#__PURE__*/React.createElement(Col, {
    lg: "5",
    className: "p-0"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      topPadding: "medium"
    }
  }, /*#__PURE__*/React.createElement(LocationFinder, _extends({}, props, {
    active: activeTab,
    setActive: setActive
  }))))));
}; //This is passing in the store values


var mapStateToProps = function mapStateToProps(state) {
  var _state$location$locat;

  return {
    //Array of locations
    results: state.location.results,
    //what ever is currently being searched for
    zipcode: state.location.zipcode,
    tripPlannerAddress: state.location.tripPlannerAddress,
    tripPlannerActive: state.location.tripPlannerActive,
    currentSelectedZip: (_state$location$locat = state.location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.postalcode,
    tripPlannerLoc: state.location.tripPlannerLoc,
    pathInfo: state.location.pathInfo
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    //function for changing map location
    changeMapLocation: function changeMapLocation(lat, lon) {
      return dispatch(locationOperations.changeMapLocation(lat, lon));
    },
    setMapActive: function setMapActive(activeIndex) {
      return dispatch(locationOperations.setMapActive(activeIndex));
    },
    setTripPlannerLoc: function setTripPlannerLoc(plannerArray) {
      return dispatch(locationOperations.setTripPlannerLoc(plannerArray));
    },
    savePathInfo: function savePathInfo(pathInfo) {
      return dispatch(locationOperations.savePathInfo(pathInfo));
    }
  };
}; //This is the store connected component


export var ConnectLocationAzureMap = connect(mapStateToProps, mapDispatchToProps)(LocationAzureMap);
export default LocationMap;